module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所在部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffDeptName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("直属领导")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.leaderName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.fillDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("请假类别"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "select_td"
    }
  }, [_c('group', [_c('selector', {
    attrs: {
      "id": "pay-type-gp",
      "title": "",
      "options": _vm.leaveTypeList
    },
    on: {
      "on-change": _vm.getLeaveType
    },
    model: {
      value: (_vm.leaveType),
      callback: function($$v) {
        _vm.leaveType = $$v
      },
      expression: "leaveType"
    }
  })], 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("特殊假期")]), _vm._v(" "), _c('td', [_c('check-icon', {
    attrs: {
      "value": _vm.specialHolidays
    },
    on: {
      "update:value": function($event) {
        _vm.specialHolidays = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("请假时间"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('flexbox', {
    attrs: {
      "gutter": 0,
      "wrap": "wrap"
    }
  }, [_c('flexbox-item', {
    attrs: {
      "span": 1 / 2
    }
  }, [_c('a', {
    staticClass: "chooseDate",
    on: {
      "click": _vm.chooseStartDate
    }
  }, [_vm._v("\n              " + _vm._s(_vm.startDate) + "\n              "), _c('img', {
    staticClass: "icon right",
    attrs: {
      "src": require("../../../assets/icon/date-blue.png"),
      "width": "18",
      "height": "18"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("~")])])]), _vm._v(" "), _c('flexbox-item', {
    attrs: {
      "span": 1 / 2
    }
  }, [_c('a', {
    staticClass: "chooseDate",
    staticStyle: {
      "padding-left": "15px"
    },
    on: {
      "click": _vm.chooseEndDate
    }
  }, [_vm._v("\n              " + _vm._s(_vm.endDate) + "\n              "), _c('img', {
    staticClass: "icon right",
    staticStyle: {
      "right": "5px"
    },
    attrs: {
      "src": require("../../../assets/icon/date-blue.png"),
      "width": "18",
      "height": "18"
    }
  })])])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("请假天数（天）"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.dateDiffer) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("请假事由"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-textarea', {
    attrs: {
      "max": 200,
      "show-counter": false,
      "height": 50,
      "rows": 4,
      "cols": 30,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.cause),
      callback: function($$v) {
        _vm.cause = $$v
      },
      expression: "cause"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("工作交接说明")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-textarea', {
    attrs: {
      "max": 200,
      "show-counter": false,
      "height": 50,
      "rows": 4,
      "cols": 30,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.explain),
      callback: function($$v) {
        _vm.explain = $$v
      },
      expression: "explain"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("外出联系方式")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-textarea', {
    attrs: {
      "max": 200,
      "show-counter": false,
      "height": 50,
      "rows": 4,
      "cols": 30,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.contactInformation),
      callback: function($$v) {
        _vm.contactInformation = $$v
      },
      expression: "contactInformation"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("附件")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('input', {
    staticClass: "inputfile",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.chooseFile
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn-file",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "box"
    }
  }), _vm._l((_vm.fileShowList), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "img-box"
    }, [_c('img', {
      staticClass: "icon-close",
      attrs: {
        "src": require("../../../assets/icon/close-blue.png")
      },
      on: {
        "click": function($event) {
          _vm.deleteFile(key)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "img-part",
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), _vm._v(" "), _c('p')], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-170421ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/launch/attendance/leaveApply.vue
// module id = 2QJ2
// module chunks = 1